(function () {
  const header = () => {
    const body = document.querySelector('body')
    const openBtn = document.querySelector('.header__offcanvas-toggle')
    const closeBtn = document.querySelector(
      '.header__offcanvas-toggle-link--close',
    )
    const offMenu = document.querySelector('.header__offcanvas-menu')
    const submenuDetails = document.querySelectorAll(
      '.header__submenu li details',
    )

    const headerHiddenMenu = document.querySelector('.header__inline-menu')

    const openMenu = (e) => {
      e.preventDefault()
      offMenu.classList.remove('header__offcanvas-menu--close')
      offMenu.classList.add('header__offcanvas-menu--open')
      openBtn.classList.add('active')
      body.classList.add('body--hidden')
      closeBtn.style.display = 'block'
      openBtn.style.display = 'none'
      headerHiddenMenu.style.display = 'none'
    }

    const closeMenu = () => {
      offMenu.classList.remove('header__offcanvas-menu--open')
      offMenu.classList.add('header__offcanvas-menu--close')
      openBtn.classList.remove('active')
      body.classList.remove('body--hidden')
      closeBtn.style.display = 'none'
      openBtn.style.display = 'block'
      headerHiddenMenu.style.display = 'block'
    }

    openBtn && openBtn.addEventListener('click', openMenu)
    closeBtn &&
			closeBtn.addEventListener('click', (e) => {
			  e.preventDefault()
			  closeMenu()
			})

    submenuDetails.forEach((targetDetail) => {
      targetDetail.addEventListener('click', () => {
        submenuDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute('open')
          }
        })
      })
    })

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        closeMenu()
        body.classList.remove('overflow-hidden')
      }
    })

    const headerOverlayAlways = document.querySelector('.overlay')

    $(window).scroll(function () {
      if ($(this).scrollTop() > 50) {
        headerOverlayAlways && $('.header').addClass('header_overlay-scroll')
      } else {
        headerOverlayAlways &&
					$('.header').removeClass('header_overlay-scroll')
      }
    })
  }

  const announcementBar = document.querySelector('.announcement-bar')
  const headerOffcanvas = document.querySelector('.header__offcanvas-wrapper')

  announcementBar &&
		headerOffcanvas &&
		headerOffcanvas.classList.add('announcement-bar-show')

  $(window).scroll(() => {
    if ($(window).scrollTop() > 100) {
      announcementBar &&
				headerOffcanvas &&
				headerOffcanvas.classList.add('announcement-bar-hide')
      announcementBar &&
				headerOffcanvas &&
				headerOffcanvas.classList.remove('announcement-bar-show')
    } else {
      announcementBar &&
				headerOffcanvas &&
				headerOffcanvas.classList.remove('announcement-bar-hide')
      announcementBar &&
				headerOffcanvas &&
				headerOffcanvas.classList.add('announcement-bar-show')
    }
  })

  document.addEventListener('shopify:section:load', header)

  header()
})()

// button-with-underline
if (window.screen.width > 990) {
  const attachedHeader = false

  const headerSection = document.querySelector('.shopify-section-header')

  const imageContainerHeader = headerSection.querySelector(
    '.button--with-underline--container',
  )

  const followMouseHeader = (event) => {
    if (imageContainerHeader) {
      imageContainerHeader.style.left = `${event.pageX}px`
      const mouseEvent =
				event.pageY - window.scrollY - headerSection.offsetHeight + 30
      imageContainerHeader.style.top = `${mouseEvent}px`
    }
  }
}

// Calculate height of the header group elements
function observeHeaderPosition () {
  const headerGroupEl = document.querySelector('.shopify-section-group-header-group')
  if (headerGroupEl) {
    const headerBottomPosition = headerGroupEl.getBoundingClientRect()?.bottom
    document.documentElement.style.setProperty('--HeaderGroup_Height', `${headerBottomPosition}px`)
  }
}

// Create a debounced version of observeHeaderPosition
const debouncedObserveHeaderPosition = window.BAO.Utils.debounce(
  observeHeaderPosition,
  100,
)

document.addEventListener('DOMContentLoaded', observeHeaderPosition)
